export default __webpack_public_path__ + "static/education-equity-accomplishment-1-89d3b7b589750e03a70919c5ab56e47c.webp";